import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {

  public logos = [
    { img: 'logo1.png',  link: 'https://www.facebook.com/boostjuicerunawaybay/' },
    { img: 'logo2.png',  link: 'http://www.bskt.com.au/' },
    { img: 'logo3.png',  link: 'http://www.coateshire.com.au/' },
    { img: 'logo4.png',  link: 'http://www.cocoongoldcoast.com/' },
    { img: 'logo5.png',  link: 'https://www.facebook.com/CoffeeBugExpress/' },
    { img: 'logo6.png',  link: 'http://www.sanctuarycovetavern.com.au/' },
    { img: 'logo7.png',  link: 'http://www.dragoncove.com.au/' },
    { img: 'logo8.png',  link: 'http://easystreetdiner.com/' },
    { img: 'logo9.png',  link: 'https://www.facebook.com/Euphoriaespressocafe/' },
    { img: 'logo10.png', link: 'http://www.hollywoodshowgirls.com.au/' },
    { img: 'logo11.png', link: 'http://www.jasmineroom.com.au/' },
    { img: 'logo12.png', link: 'https://www.facebook.com/Kiwi-Fish-N-Chips-275881965758230/' },
    { img: 'logo13.png', link: 'https://www.facebook.com/LittleMynxcafe/' },
    { img: 'logo14.png', link: 'http://www.marieanitas.com.au/' },
    { img: 'logo15.jpg', link: 'http://www.mariespizza.com.au/' },
    { img: 'logo16.png', link: 'http://www.mosburger.com.au/' },
    { img: 'logo17.png', link: 'http://www.runawaybayjuniors.com.au/' },
    { img: 'logo18.png', link: 'http://igarobina.com.au/' },
    { img: 'logo19.png', link: 'http://www.superiorcare.com.au/' },
    { img: 'logo20.png', link: 'https://www.facebook.com/atthaionferry/' },
    { img: 'logo21.png', link: 'http://www.tss.qld.edu.au/' },
    { img: 'logo22.png', link: 'http://www.titans.com.au/' },
    { img: 'logo23.png', link: 'http://www.toniconchirn.com.au/' },
    { img: 'logo24.png', link: 'https://www.facebook.com/wagyuyaonchevron/' },
  ];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/customers/customers.component.ts